import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from '../../../constants';

@Injectable()
export class CommonService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http: Http) { }

	getState(token) {
		return this.http
		.get(this.apiUrl + "state/v1/getstates?$orderby=Nome asc$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getCity(token, stateID) {
		return this.http
		.get(this.apiUrl + "city/v1/getcitybystate/" + stateID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/common/service/common.service.ts